export default __webpack_public_path__ + "images/newIframe/get-started-new@2x.png";